import controller from './sliders-t1.controller';
import template from './sliders-t1.view.html';

let SlidersT1Component = {
  template,
  controller,
  bindings : {
    cbItems : '<',
    cbName : '<'
  }
};

export default SlidersT1Component;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/sliders/sliders-t1/sliders-t1.component.js
 **/